module.exports = __webpack_public_path__ + "static/img/avatar.26db1a88.jpg";